import FloatIcon from './FloatIcon';

export default FloatIcon;
